import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=8a5bd9a8&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5bd9a8",
  null
  
)

export default component.exports